import {
  MASTERDATA_CENTRAL_ROLE_IDS,
  MASTERDATA_BRANCH_ROLE_IDS,
} from "@/constants/roles";

/**
 * กฎเพิ่ม/แก้/ลบ master list — ต้องผ่านทั้งสองข้อพร้อมกัน
 *   1. มี central role (C_LEVEL / ACCOUNTANT / PROCUREMENT) เป็น scope clinic_wide
 *      ของคลินิกที่โหลด context ไว้ — RDM ไม่นับเพราะเป็น branch_subset
 *   2. มี MANAGER เป็น scope branch ของสาขาที่กำลังเปิดอยู่
 *
 * แยกออกมาเป็น pure function เพราะ src/stores/user.js import "@/main" ซึ่งลาก
 * ทั้งแอปเข้ามา ทำให้ jest เทส getter ตรงๆ ไม่ได้
 *
 * fail-closed — ระหว่าง permissionContext ยังโหลดไม่เสร็จหรือยังไม่รู้สาขา
 * จะคืน false เสมอ ปุ่มไม่โผล่ดีกว่าโผล่แล้วกดไม่ได้
 *
 * @param {{ scopes: Array<object> }|null} permissionContext ผลจาก GET /api/auth/context
 * @param {number|null|undefined} branchId id ของสาขาที่กำลังเปิดอยู่
 * @returns {boolean}
 */
export function canManageMasterData(permissionContext, branchId) {
  if (branchId === null || branchId === undefined) return false;

  const scopes = permissionContext && permissionContext.scopes;
  if (!Array.isArray(scopes)) return false;

  // BE push scope clinic_wide แยกทีละ roleId (resolver.js) จึงต้องวนทุก scope
  // ไม่ใช่มองหา scope เดียวที่มี role ครบ
  const hasCentral = scopes.some(
    s =>
      s.type === "clinic_wide" &&
      Array.isArray(s.roleIds) &&
      s.roleIds.some(id => MASTERDATA_CENTRAL_ROLE_IDS.includes(id))
  );
  if (!hasCentral) return false;

  return scopes.some(
    s =>
      s.type === "branch" &&
      s.branchId === branchId &&
      Array.isArray(s.roleIds) &&
      s.roleIds.some(id => MASTERDATA_BRANCH_ROLE_IDS.includes(id))
  );
}

export default canManageMasterData;
